import { useEffect } from "react";

import { ServerToClientEvents, SocketEvents } from "@common/models/webSocketEvents";
import useNotificationsApiConsumer from "@main/consumers/useNotificationsApiConsumer";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { Socket } from "socket.io-client";

interface Params {
  socket?: Socket<ServerToClientEvents, never>;
  refetchData?: () => void;
}

export default function useUserFeedbackAppendSocketConsumer({ socket, refetchData }: Params) {
  const { selectedWorkspace } = useAppSelectionContext();
  const { fetchUnreadNotificationsAndDispatch } = useNotificationsApiConsumer();

  useEffect(() => {
    if (!selectedWorkspace || !socket) return;

    const handleIssueAppendEvent = async () => {
      if (selectedWorkspace.notify_new_bug) {
        await fetchUnreadNotificationsAndDispatch(selectedWorkspace.id);
      }
      refetchData?.();
    };

    socket.on(SocketEvents.APPEND_ISSUE, handleIssueAppendEvent);
    return () => {
      socket.off(SocketEvents.APPEND_ISSUE, handleIssueAppendEvent);
    };
  }, [selectedWorkspace, socket, fetchUnreadNotificationsAndDispatch, refetchData]);
}
